import * as React from 'react';
import type { SVGProps } from 'react';

const LinkSvg = ({ width = 12, height = 12, fill = '#616061', ...props }: SVGProps<SVGSVGElement>) => (
  <svg width={width} height={height} viewBox="0 0 12 12" fill={fill} xmlns="http://www.w3.org/2000/svg" {...props}>
    <g id="Icon/Link">
      <g id="Icon">
        <path
          d="M5.28769 1.15177C6.02508 0.414383 7.02519 0.00012207 8.06802 0.00012207C10.2396 0.00012207 12 1.76053 12 3.9321C12 4.97493 11.5857 5.97504 10.8484 6.71243L9.31066 8.25012L8.25 7.18946L9.78769 5.65177C10.2438 5.19569 10.5 4.5771 10.5 3.9321C10.5 2.58896 9.41117 1.50012 8.06802 1.50012C7.42302 1.50012 6.80443 1.75635 6.34835 2.21243L4.81066 3.75012L3.75 2.68946L5.28769 1.15177Z"
          fill={fill}
        />
        <path
          d="M5.65165 9.78781L7.18934 8.25012L8.25 9.31078L6.71231 10.8485C5.97492 11.5859 4.97481 12.0001 3.93198 12.0001C1.76041 12.0001 0 10.2397 0 8.06814C0 7.02532 0.41426 6.0252 1.15165 5.28781L2.68934 3.75012L3.75 4.81078L2.21231 6.34847C1.75623 6.80456 1.5 7.42314 1.5 8.06814C1.5 9.41129 2.58883 10.5001 3.93198 10.5001C4.57698 10.5001 5.19557 10.2439 5.65165 9.78781Z"
          fill={fill}
        />
        <path d="M4.28033 8.78045L8.78033 4.28045L7.71967 3.21979L3.21967 7.71979L4.28033 8.78045Z" fill={fill} />
      </g>
    </g>
  </svg>
);

export default LinkSvg;
